import React, {Component} from "react";
import {Modal} from "react-bootstrap";
import DataTable from "react-data-table-component";
import {connect} from "react-redux";
import {CustomerCustomersList} from "../../../redux/actions/Modules.Action";
import ApiConnect from "../../../Utils/ApiConnect";
import DispatchEmployee from "./Components/DispatchEmployee";
import DispatchLabel from "./Components/DispatchLabel";
import OrderDetils from "./Components/OrderDetils";

class PendingBooking extends Component {
  constructor(props) {
    super(props);
this.state = {
      BookingData: [],
      showModal: false,
      modalView: false,
      selectedId: false,
      filterText: "",
    };
    this.columns = [
      {
        name: "Booking ID",
        selector: row => row.id,
        cell: (row) => {
          return (
            <a
              href="#_"
              onClick={() => {
                this.setState({
                  showModal: true,
                  modalView: <OrderDetils BookingDetails={row} />,
                });
              }}
            >
              {row.id}
            </a>
          );
        },
      },
      {
        name: "Date",
        selector: row => row.date,
        sortable: true,
      },
      {
        name: "Location",
        selector: row => row.location,
      },
      {
        name: "Total Items",
        selector: row => row.total_items,
        sortable: true,
      },
      {
        name: "Total Amount",
        selector: row => row.total_amount,
      },
      {
        name: "Order Att",
        selector: row => row.user,
        cell: (row) => {
          return (
            <React.Fragment>
              <img
                className="avatar"
                src={row.user.avatar}
                alt={row.user.name}
              />
            </React.Fragment>
          );
        },
      },

      {
        name: "Action",
        selector: row => row.action,
        className: "table-actions",
        sortable: false,
        cell: (row, i) => {
          return (
            <React.Fragment key={i}>
              <button
                className="table-action btn btn-square btn-pure hover-warning"
                onClick={() => {
                  this.setState({
                    showModal: true,
                    modalView: (
                      <>
                        <DispatchEmployee
                          BookingDetails={row}
                          trigger={this.modalFallback}
                        />
                        <DispatchLabel BookingDetails={row} />
                      </>
                    ),
                  });
                }}
              >
                <span className="material-icons-outlined fs-35">
                  assignment_ind
                </span>
              </button>
            </React.Fragment>
          );
        },
      },
      ];
  }

  customStyles = {
    headCells: {
      style: {
        padding: "12px 16px",
        fontWeight: "bold",
        fontSize: "14px",
        backgroundColor: "#f8f9fa",
      },
    },
    cells: {
      style: {
        padding: "10px 16px",
        fontSize: "13px",
      },
    },
  };

  componentDidMount() {
    this.fetchCustomer();
  }
  fetchCustomer() {
    ApiConnect.get("/Module/Booking/Main/Details")
      .then((response) => {
        this.setState({ BookingData: response.data });
      })
      .catch((error) => console.log(error));
  }

  modalFallback = () => {
    this.fetchCustomer();
    this.setState({ showModal: false });
  };
  render() {
    return (
      <div className="col-md-12 col-xl-12">
        <div className="card">
          <header className="header no-border">
            <div className="header-info">
              <div className="left">
                <h2 className="header-title">
                  <strong>Pending Booking</strong>
                </h2>
              </div>
            </div>
            <div className="header-action"></div>
          </header>
          <div className="card-body">
            <div className="dataTables_wrapper">
              <div className="mb-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search..."
                  onChange={e => this.setState({ filterText: e.target.value })}
                />
              </div>
              <DataTable
                className="table table-separated"
                keyField="id"
                columns={this.columns}
                data={this.state.BookingData.filter(item =>
                  Object.values(item).some(val =>
                    String(val).toLowerCase().includes(this.state.filterText.toLowerCase())
                  )
                )}
                pagination
                paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
                paginationPerPage={10}
                customStyles={this.customStyles}
                filter
                exportable
              />
            </div>
          </div>
          <Modal
            show={this.state.showModal}
            className="modal-center"
            onHide={() => this.setState({ showModal: false })}
          >
            <Modal.Dialog>
              <Modal.Header>
                <h5 className="modal-title">Quick Preview</h5>
                <button
                  type="button"
                  className="btn"
                  onClick={() => this.setState({ showModal: false })}
                >
                  <span className="material-icons-outlined">close</span>
                </button>
              </Modal.Header>
              {this.state.modalView}
            </Modal.Dialog>
          </Modal>
        </div>
      </div>
    );
  }
}
export default connect(
  (state) => ({
    CustomerList: state.Customer.CustomerList,
  }),
  { CustomerCustomersList }
)(PendingBooking);
